export class MaximumSubCategory {
    public id: number;
    public SubCategory: String;
    public CategoryId: number;
    public IsSupport: boolean;
    public Description: String;
    public LastUpdate: Date;
    public UpdatedBy: String;
}



// WEBPACK FOOTER //
// ./src/app/models/maximumsubcategory.ts